// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"524fc2ea","453":"c81f4748","455":"90cc7fa1","977":"7be8814e"}[chunkId] + ".chunk.js";
};